export default __webpack_public_path__ + "static/media/loadingLogo.b8c8d83d.svg";